import Axios from "axios";
import config from "../configs";
import {store} from "../models";
import {message} from "antd";
import sha1 from "sha1";

const service = Axios.create({
    baseURL: config.BASE_API,
})

service.interceptors.request.use(request => {
    const userToken = store.getState().auth.userToken
    if (userToken) {
        request.headers['Authorization'] = `Bearer ${userToken}`
    }

    const queryParams = {...request.params} || {}
    const [, query] = (request.url || "").split('?')
    if (query) {
        query.split("&").map(item => item.split("=")).forEach(item => queryParams[item[0]] = item[1])
    }

    const params = Object.keys(queryParams).sort().map(item => queryParams[item]).join('')
    const nonce = Math.random().toString(36).substr(2)
    const timestamp = (Date.now().valueOf() / 1000).toFixed(0)
    const salt = config.SHA1_SALT
    const signature = sha1(`${params}${nonce}${timestamp}${salt}`)

    request.headers['Nonce'] = nonce
    request.headers['Timestamp'] = timestamp
    request.headers['Signature'] = signature
    return request
})

service.interceptors.response.use(response => response, error => {
    if (error.response && (error.response.status === 401)) {
        store.dispatch.auth.logout()
    } else if (error.response && error.response.data.message) {
        message.error(error.response.data.message)
    }
    return Promise.reject(error)
})

export default service
